export const buildColumns = (columns = []) => {
	return columns.map(
		({
			name,
			label,
			sort = true,
			filter = false,
			viewColumns = true,
			render,
			headRender,
			cellProps,
		}) => ({
			name,
			label,
			options: {
				sort,
				filter,
				viewColumns,
				customBodyRender: render,
				customHeadRender: headRender,
				setCellProps: cellProps,
			},
		})
	);
};

const defaultOptions = {
	jumpToPage: true,
	selectableRows: "none",
	download: false,
	filter: false,
	viewColumns: true,
	serverSide: true,
	print: false,
};
export const buildOptions = (options = {}) => {
	return { ...defaultOptions, ...options };
};
